import Admin from "layouts/Admin.js";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Route, Switch } from "react-router-dom";
import Actions from "redux/actions";
import reducer from "redux/reducers";
import withReducer from "redux/withReducer";

class Router extends React.Component {
  componentDidMount() {
    this.props.dispatch(Actions.initAppVersion());
    this.props.dispatch(Actions.fetchApiVersion()).catch(() => null);
    this.tryAutoLogin();
  }
  tryAutoLogin = () => {
    const isValidationRoute = /\/quitance\/validation\//i.test(
      window.location.pathname
    );
    if (isValidationRoute) {
      this.props.dispatch({ type: Actions.SET_LOGIN, payload: false });
      return;
    }
    if (this.props.user) return;
    this.props.dispatch(Actions.autoLogin()).then((state) => {
      if (!state.logged) {
        this.props.dispatch(Actions.logout());
        this.props.history.push("/login");
      } else if (state.logged) {
      } else if (state.wasLogged) {
        this.props.dispatch(Actions.logout());
        this.props.history.push("/login");
      } else {
        this.props.dispatch(Actions.logout());
        this.props.history.push("/404");
      }
    });
  };

  render() {
    return (
      <Switch>
        <Route component={Admin} />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.reducer.user });
export default withRouter(
  withReducer("reducer", reducer)(connect(mapStateToProps)(Router))
);
